const DUMMY_API_URL = "https://httpbin.org/post";

export const submitPayloadToDummyApi = async (label, payload) => {
  console.group(`[RouteMaster] ${label}`);
  console.log("Submit payload:", payload);
  console.log("Submit payload (JSON):", JSON.stringify(payload, null, 2));
  console.groupEnd();

  const response = await fetch(DUMMY_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      label,
      submittedAt: new Date().toISOString(),
      payload,
    }),
  });

  if (!response.ok) {
    throw new Error(`Dummy API failed with status ${response.status}`);
  }

  const result = await response.json();
  console.log(`[RouteMaster] ${label} - dummy API echoed data:`, result?.json);

  return {
    success: true,
    payload,
    dummyApiResponse: result,
  };
};
